export const isCompareSubject = (subjects, id) => {
  const isSame =
    (subjects[0] && subjects[0].id === id) ||
    (subjects[1] && subjects[1].id === id);

  return isSame;
};

/**
 * Check if any items are partially rectified
 * @param {array} items - Array of items
 * @returns {bool} whether or not some items are partially rectified
 */
export const hasPartialRectification = items =>
  items.some(
    item =>
      item.properties.ground_control === false ||
      item.properties.ground_control_ratio < 1.0
  );
